import { Or, Rule, StringEquals } from '@vendasta/automata';
import { RulePath } from './consts';

// pipeline statuses keys
export enum OpportunityStatus {
  Open = 'open',
  ClosedAny = 'closed-any',
  ClosedWon = 'closed-won',
  ClosedLost = 'closed-lost',
}

export function I18NKey(status: OpportunityStatus | string): string {
  switch (status) {
    case OpportunityStatus.ClosedAny:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STATUS_OPTIONS.CLOSED_ANY';
    case OpportunityStatus.ClosedWon:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STATUS_OPTIONS.CLOSED_WON';
    case OpportunityStatus.ClosedLost:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STATUS_OPTIONS.CLOSED_LOST';
    case OpportunityStatus.Open:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STATUS_OPTIONS.OPEN';
    default:
      return '';
  }
}

const openRule = new StringEquals(RulePath.pipelineStatusPath, OpportunityStatus.Open, '');
const closedAnyRule = new Or(
  [
    new StringEquals(RulePath.pipelineStatusPath, OpportunityStatus.ClosedWon, ''),
    new StringEquals(RulePath.pipelineStatusPath, OpportunityStatus.ClosedLost, ''),
  ],
  '',
);
const closedLostRule = new StringEquals(RulePath.pipelineStatusPath, OpportunityStatus.ClosedLost, '');
const closedWonRule = new StringEquals(RulePath.pipelineStatusPath, OpportunityStatus.ClosedWon, '');

export function getRule(status: OpportunityStatus): Rule | undefined {
  switch (status) {
    case OpportunityStatus.ClosedAny:
      return closedAnyRule;
    case OpportunityStatus.ClosedWon:
      return closedWonRule;
    case OpportunityStatus.ClosedLost:
      return closedLostRule;
    case OpportunityStatus.Open:
      return openRule;
    default:
      return undefined;
  }
}
